import type Immutable from 'immutable'
import type { Dispatch } from 'redux'

import { basketDateChange, basketSlotChange } from 'actions/basket'
import { redirect } from 'actions/redirect'
import { availablePortions } from 'config/portionSizes'

import type { GetState } from './types'

export const setSlotFromIds =
  (slotId?: string | null, dayId?: string | null) =>
  (dispatch: Dispatch<any>, getState: GetState) => {
    const { boxSummaryDeliveryDays } = getState()
    if (dayId) {
      const day = boxSummaryDeliveryDays.find(
        (deliveryDay: Immutable.Map<string, any>) => deliveryDay.get('coreDayId') === dayId,
      )
      if (day) {
        const date = day.get('date')
        dispatch(basketDateChange(date))
        let slotIdToSet = ''
        if (slotId) {
          const matchingSlot = day
            .get('slots')
            .find((slot: Immutable.Map<string, any>) => slot.get('coreSlotId') === slotId)
          slotIdToSet = matchingSlot ? matchingSlot.get('id') : ''
        }
        dispatch(basketSlotChange(slotIdToSet))
      } else {
        dispatch(redirect('/menu'))
      }
    }
  }

export const parseNumPortions = (numPortions?: string | null) => {
  const parsedNumPortions = Number(numPortions)

  const isValidNumPortions =
    !Number.isNaN(parsedNumPortions) && availablePortions.includes(parsedNumPortions)

  return isValidNumPortions ? parsedNumPortions : undefined
}
